export default __webpack_public_path__ + "static/media/archer.86bdbb05.png";